export interface TourCategoryMeta {
  label: string;
  description?: string;
  id: TourCategories,
  priority: number,
}

export type TourCategories = "Basics" | "Admin" | "Orders" | "Projects"

export const tourCategories: Record<TourCategories, TourCategoryMeta> = {
  Basics: {
    id: "Basics",
    label: 'Getting Started',
    description: 'Start here if you’re new to the platform.',
    priority: 0
  },
  Admin: {
    id: "Admin",
    label: 'Organizations',
    description: 'About organizations, their role on spcfy and how you can manage your own organization.',
    priority: 1
  },
  Orders: {
    id: "Orders",
    label: 'Order Management',
    description: 'Information about creating, managing and handling orders .',
    priority: 2
  },
  Projects: {
    id: "Projects",
    label: 'Spcfy Insight Projects',
    description: 'Make the most of spcfy with its Insight features',
    priority: 3
  },
};